import Vue from 'vue';
import utils from  '../utils'
Vue.filter('formatPrice', function (val){
  return utils.formatPrice(val)
});

Vue.filter('formatThousand', function (value) {
  if (isNaN(value)) {
    return "";
  }
  return (value / 1000);
});


Vue.filter('formatPercent', function (value) {
  if (isNaN(value)) {
    return "";
  }
  return (value * 100)+" %";
});



// WEBPACK FOOTER //
// ./src/filters/price.js